import React from "react";
import CaseStudys from "../index";
import styles from "./styles.module.scss";

import aryafireandsafetybanner from "../../../assets/casestudy/aryafireandsafetybanner.png";
import aryafireandsafety1img from "../../../assets/casestudy/aryafireandsafety1img.png";
import aryafireandsafety2img from "../../../assets/casestudy/aryafireandsafety2img.png";
import aryafireandsafety3img from "../../../assets/casestudy/aryafireandsafety3img.png";

import KumarPhotography from "../../../assets/img/KumarPhotoGraphy.png";
import Mongodbicon from "../../../assets/img/mongodbicon.svg";
import Nodeicon from "../../../assets/img/nodeicon.svg";
import Reacticon from "../../../assets/img/reacticon.svg";
import Expressicon from "../../../assets/img/expressicon.svg";

import KudlaBuilders from "../../../assets/casestudy/kudlabuilders.png";
import hilightlightingstudio1img from "../../../assets/casestudy/hilightlightingstudio1img.png";

const AryaFireandSafety = () => {
  const caseStudiesB = [
    {
      image: KudlaBuilders,
      title: "KudlaBuilders",
      category: "Website Design",
      pagelink: "/kudla-builders",
      link: "https://kudlabuilders.com/",
    },
    {
      image: hilightlightingstudio1img,
      title: "HilightLightingStudio",
      category: "Website Design",
      pagelink: "/hilight-lighting-studio",
      link: "https://aryafireandsafety.com/",
    },
  ];
  const servicesB = [
    { label: "UI & UX Design", link: "https://metasoft.ae/services" },
    { label: "Web Development", link: "https://metasoft.ae/services" },
    { label: "Performance Optimization", link: "https://metasoft.ae/services" },
    { label: "SEO", link: "https://metasoftdm.com/marketing-solutions/seo/" },
  ];
  return (
    <CaseStudys
      title="AryaFireandSafety"
      caseStudies={caseStudiesB}
      subtitle="Complete Fire & Safety Solutions for Every Industry"
      header="Complete Fire & Safety Solutions for Every Industry"
      websiteUrl="https://aryafireandsafety.com/"
      industry="Fire Safety & Protection Services"
      services={servicesB}
      description={
        <>
          <span>Arya Fire & Safety </span> Arya Fire & Safety is a trusted fire
          protection company committed to delivering reliable, compliant, and
          high-quality safety solutions for businesses and homes. To showcase
          their expertise and comprehensive range of products and services, we
          developed a clean and professional digital presence that reflects
          their credibility and long-standing commitment to safety. The website
          highlights their equipment, installation services, and training
          programs with clarity, offering users a smooth browsing experience
          that builds trust and makes it easy to explore and understand their
          fire safety offerings.
        </>
      }
      objective={{
        heading:
          "Creating a Credible and Informative Platform for Arya Fire & Safety",
        content: (
          <>
            <p className={styles.projectText}>
              The objective of the Arya Fire & Safety website project was to
              create a professional and trustworthy digital presence that
              reflects the brand’s commitment to reliable, compliant, and
              comprehensive fire protection solutions. Our goal was to design a
              clean, organized platform that clearly showcases their range of
              equipment, installation services, and training programs. This
              project aimed to communicate Arya Fire & Safety’s credibility,
              highlight their expertise and long-standing industry presence, and
              provide users with a seamless browsing experience that simplifies
              decision-making—ultimately helping businesses and individuals find
              the right fire safety solutions with confidence while
              strengthening engagement in a highly competitive safety services
              market.
            </p>
          </>
        ),
      }}
      process={{
        heading: "How We Created a Clean and User-Friendly Digital Platform",
        content: (
          <>
            <p className={styles.projectText}>
              The project began with a deep understanding of Arya Fire &
              Safety’s brand expertise, service offerings, and the expectations
              of businesses and individuals seeking reliable fire protection
              solutions. With this foundation, we mapped a user journey focused
              on clarity, trust, and easy access to safety information and
              services. During the design phase, we emphasized clean layouts,
              structured content, and visuals that reflect professionalism and
              industry credibility. Our development process centered on creating
              a fast, responsive, and user-friendly website that ensures smooth
              navigation, quick access to product and service details, and
              optimal mobile performance. Regular client reviews maintained
              alignment throughout, and extensive testing delivered a polished,
              reliable, and confidence-inspiring digital experience at launch.
            </p>
          </>
        ),
      }}
      impact={{
        heading:
          "How the New Online Presence Boosted Arya Fire & Safety’s Customer Engagement",
        content: (
          <>
            <p className={styles.projectText}>
              The launch of the Arya Fire & Safety website significantly
              enhanced the brand’s digital presence, providing businesses and
              individuals with a clear and trustworthy way to explore fire
              safety solutions. The organized layout, intuitive navigation, and
              well-structured content improved user understanding while
              reinforcing confidence in the brand’s expertise and reliability.
              With faster access to product and service details, seamless mobile
              performance, and an overall smoother browsing experience, the
              website has helped increase user engagement and broaden reach
              within the fire safety market. As a result, the platform now
              serves as a professional and dependable touchpoint that supports
              informed decision-making and strengthens Arya Fire & Safety’s
              brand reputation.
            </p>
          </>
        ),
      }}
      conclusion={{
        heading: "Wrapping Up the Project",
        content: (
          <>
            <p className={styles.projectText}>
              In conclusion, the Arya Fire & Safety website effectively
              reflected the brand’s dedication to reliable, compliant, and
              professional fire protection solutions. By combining a clean,
              organized design with seamless functionality, the platform now
              serves as a powerful tool for showcasing products and services,
              building trust, and guiding users toward informed safety
              decisions. The project not only elevated the brand’s digital
              presence but also reinforced Arya Fire & Safety’s position as a
              credible and dependable partner in the competitive fire safety
              market, supporting ongoing growth and long-term industry
              leadership.
            </p>
          </>
        ),
      }}
      heroImage={aryafireandsafetybanner} // Add the hero image
      projectImage={aryafireandsafety1img}
      projectImage2={aryafireandsafety2img}
      projectImage3={aryafireandsafety3img}
      // Add the project image
      technologies={[
        { name: "MongoDB", icon: Mongodbicon },
        { name: "Node.js", icon: Nodeicon },
        { name: "React", icon: Reacticon },
        { name: "Express.js", icon: Expressicon },
      ]} // Add the technologies used
      timescale="On-going" // Add the timescale
      launchDate="Aug 2025" // Add the launch date
    />
  );
};

export default AryaFireandSafety;
